import React, { useId } from "react";
import AuthImage from "@/components/AuthImage";

const PALETTES = [["#0A192F", "#17466B"], ["#0B2A3A", "#0E5E6F"], ["#141A3A", "#2E3A7A"], ["#2A1A0F", "#6B3F1D"], ["#0F2A1E", "#1F5C45"]];
const hash = (s) => Array.from(s || "").reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);
export const initialsOf = (name) => ((name || "?").trim().split(/\s+/).map((n) => n[0]).slice(0, 2).join("").toUpperCase() || "?");

// Classy gold/navy monogram — the stylised fallback for brothers without a profile photo
export function Monogram({ name, className = "h-10 w-10", testid }) {
  const id = useId().replace(/:/g, "");
  const [c1, c2] = PALETTES[hash(name) % PALETTES.length];
  const ini = initialsOf(name);
  return (
    <svg viewBox="0 0 100 100" className={`${className} shrink-0 rounded-full`} role="img" aria-label={name || "member"} data-testid={testid}>
      <defs>
        <radialGradient id={`g${id}`} cx="35%" cy="28%" r="85%"><stop offset="0%" stopColor={c2} /><stop offset="100%" stopColor={c1} /></radialGradient>
      </defs>
      <circle cx="50" cy="50" r="50" fill={`url(#g${id})`} />
      <path d="M-10 80 Q 10 70 30 80 T 70 80 T 110 80 V110 H-10Z" fill="rgba(14,165,233,0.22)" />
      <path d="M-10 88 Q 10 80 30 88 T 70 88 T 110 88 V110 H-10Z" fill="rgba(6,182,212,0.18)" />
      <circle cx="50" cy="50" r="47" fill="none" stroke="#D4AF37" strokeOpacity="0.8" strokeWidth="2.5" />
      <text x="50" y="50" dy=".36em" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontWeight="700" fontSize={ini.length > 1 ? 36 : 44} fill="#D4AF37" letterSpacing="1">{ini}</text>
    </svg>
  );
}

export default function MemberAvatar({ name, photo, className = "h-10 w-10", testid }) {
  if (photo) return <AuthImage path={photo} className={`${className} shrink-0 rounded-full object-cover`} fallback={<Monogram name={name} className={className} testid={testid} />} />;
  return <Monogram name={name} className={className} testid={testid} />;
}
